import i18n from '@/plugins/i18n';

export const getEmployeeTableHeaders = (vm) => {
  return [
    {
      text: i18n.t( 'table.header.status'),
      align: 'start',
      value: 'isAdmin'
    },
    {
      text: i18n.t( 'table.header.status'),
      align: 'end',
      value: 'status'
    },
    {
      text: i18n.t('table.header.first.name'),
      align: 'start',
      filterable: true,
      value: 'firstName'
    },
    {
      text: i18n.t('table.header.last.name'),
      align: 'start',
      filterable: true,
      value: 'lastName'
    },
    {
      text: i18n.t( 'table.header.email'),
      align: 'start',
      filterable: true,
      value: 'email'
    },
    {
      text: i18n.t( 'table.header.inboxes'),
      align: 'start',
      value: 'inboxes',
      isHidden: !vm.$permissions.hasInput,
      sortable: false
    },
    {
      text: i18n.t( 'table.header.settings'),
      align: 'center',
      width: '80px',
      value: 'userSettings',
      isHidden: !vm.$permissions.hasOutput,
      sortable: false
    },
    {
      text: i18n.t('table.header.lock.settings'),
      align: 'end',
      width: '80px',
      value: 'userSettingsLocked',
      isHidden: !vm.$permissions.hasOutput,
      sortable: false,
      apiName: 'lockUserSettings'
    },
    {
      text: i18n.t( 'table.header.output.merge'),
      align: 'end',
      width: '80px',
      value: 'orgaMergeEnabled',
      isHidden: !vm.$permissions.hasOutput,
      sortable: false,
      apiName: 'setOrgaMerge'
    },
    {
      text: i18n.t( 'table.header.actions'),
      align: 'end',
      value: 'action',
      sortable: false
    }
  ].filter((header) => {
    return !header.isHidden
  });
}
